export default __webpack_public_path__ + "static/media/sample_doll.2bab9b87.jpg";